export enum StatusCodes {
  ok = 200,
  unauthorized = 401,
  forbidden = 403,
  badRequest = 400
}
